import moment from "moment";
import { configurations } from "../configurations";
import { getCurrencySymbol } from "../features/utils/countires";
import { formatMoney } from "../features/utils/formatMoney";
import {
  accommodationTravellersString,
  calculateStayNights,
} from "./hotelUIController";
import { parseFlightRoutesAndTripType } from "./flightUIController";

export const invoiceTaxCalculation = ({ services, data }) => {
  const total = services?.reduce((acc, current) => {
    return acc + (current?.unitPrice || 0) * (current?.quantity || 0);
  }, 0);
  let currency = services?.find((service) => service?.currency === "USD")
    ? "USD"
    : "NGN";

  const taxValue = parseFloat(data?.tax?.value || 0);
  const method = data?.tax?.taxMethod;

  let amount = 0;

  if (method === "Percentage") {
    amount = (taxValue / 100) * total;
  } else if (method === "Fixed") {
    amount = taxValue;
  } else {
    amount = 0;
  }
  return {
    value: formatMoney(amount, getCurrencySymbol(currency)),
    amount,
  };
};

export const invoiceServiceFeeCalculation = ({ services, data }) => {
  const total = services?.reduce((acc, current) => {
    return acc + (current?.unitPrice || 0) * (current?.quantity || 0);
  }, 0);
  let currency = services?.find((service) => service?.currency === "USD")
    ? "USD"
    : "NGN";

  const serviceFeeValue = parseFloat(data?.serviceFee?.value || 0);
  const method = data?.serviceFee?.feeMethod;

  let amount = 0;

  if (method === "Percentage") {
    amount = (serviceFeeValue / 100) * total;
  } else if (method === "Fixed") {
    amount = serviceFeeValue;
  } else {
    amount = 0;
  }
  return {
    value: formatMoney(amount, getCurrencySymbol(currency)),
    amount,
  };
};

export const invoiceSelectedServices = ({ data, services, fetched }) => {
  if (fetched) {
    return data?.services;
  }
  if (data?.services && data?.services?.length) {
    const populated = null;
    // const populated = data?.services?.find((service) => service?.unitPrice);
    // console.log({ populated });

    if (!services?.length && !populated) return [];
    const items = data?.services?.map((service) => {
      let item = populated
        ? service
        : services?.find((serv) => serv?._id === service?.service);
      return {
        ...service,
        service: item,
      };
    });
    return items;
  }
  let bookings = [
    ...(data?.flightBookings || [])?.map((booking) => {
      return {
        bookingId: booking?._id,
        data: booking,
        orderType: configurations.products.flight.value,
      };
    }),
    ...(data?.hotelBookings || [])?.map((booking) => {
      return {
        bookingId: booking?._id,
        data: booking,
        orderType: configurations.products.stay.value,
      };
    }),
    ...(data?.packageBookings || [])?.map((booking) => {
      return {
        bookingId: booking?._id,
        data: booking,
        orderType: configurations.products.tour.value,
      };
    }),
    ...(data?.insuranceBookings || [])?.map((booking) => {
      return {
        bookingId: booking?._id,
        data: booking,
        orderType: configurations.products.insurance.value,
      };
    }),
  ];
  if (bookings?.length) {
    return bookings?.map((booking) => {
      switch (booking?.orderType) {
        case configurations.products.stay.value:
          return {
            title: booking?.data?.requestBody?.name,
            description: booking?.data?.requestBody?.rooms
              ?.map((room) => room?.name)
              ?.join(", "),
            amount: booking?.data?.fareTotalPrice || booking?.data?.grandTotal,
            currency: booking?.currency,
            price: formatMoney(
              booking?.data?.fareTotalPrice || booking?.data?.grandTotal
            ),
          };
        case configurations.products.tour.value:
          return {
            title: booking?.data?.extraDetails?.productInfo?.title,
            description: booking?.data?.extraDetails?.productInfo?.description,
            amount: booking?.data?.fareTotalPrice || booking?.data?.grandTotal,
            currency: booking?.currency,
            price: formatMoney(
              booking?.data?.fareTotalPrice || booking?.data?.grandTotal
            ),
          };
        case configurations.products.flight.value:
          const flight = parseFlightRoutesAndTripType({
            destinations:
              booking?.data?.flightObj?.destinations ||
              booking?.data?.destinations,
          });
          const amount =
            booking?.data?.flightObj?.grandTotal || booking?.data?.grandTotal;
          return {
            title: flight?.routes,
            description: flight?.tripType,
            amount: amount,
            currency: booking?.currency,
            price: formatMoney(
              amount,
              booking?.currency === "USD" ? "$" : undefined
            ),
          };
        default:
          return {
            title: booking?.title,
            description: booking?.description?.join(", "),
            amount: booking?.unitPrice,
            currency: booking?.currency,
            price: formatMoney(
              booking?.unitPrice,
              booking?.currency === "USD" ? "$" : undefined
            ),
          };
      }
    });
  }
  return [];
};

export const invoicePDF = ({ user, invoice }) => {
  let nameArray = [];
  if (invoice?.customer?.firstName)
    nameArray = [...nameArray, invoice?.customer?.firstName];
  if (invoice?.customer?.middleName)
    nameArray = [...nameArray, invoice?.customer?.middleName];
  if (invoice?.customer?.lastName)
    nameArray = [...nameArray, invoice?.customer?.lastName];

  let services = [];

  if (invoice?.services?.length) {
    services = invoice?.services?.map((service) => {
      return {
        title: service?.service?.title,
        quantity: service?.quantity || 1,
        amount: service?.unitPrice * service?.quantity || 1,
        price: formatMoney(service?.unitPrice),
        total: formatMoney(service?.unitPrice * service?.quantity || 1),
        details: service?.service?.description || [],
      };
    });
  } else {
    let bookings = [
      ...(invoice?.flightBookings || [])?.map((booking) => {
        return {
          bookingId: booking?._id,
          booking,
          orderType: configurations.products.flight.value,
        };
      }),
      ...(invoice?.hotelBookings || [])?.map((booking) => {
        return {
          bookingId: booking?._id,
          booking,
          orderType: configurations.products.stay.value,
        };
      }),
      ...(invoice?.packageBookings || [])?.map((booking) => {
        return {
          bookingId: booking?._id,
          booking,
          orderType: configurations.products.tour.value,
        };
      }),
      ...(invoice?.insuranceBookings || [])?.map((booking) => {
        return {
          bookingId: booking?._id,
          booking,
          orderType: configurations.products.insurance.value,
        };
      }),
    ];

    services = bookings?.map((booking) => {
      switch (booking?.orderType) {
        case configurations.products.stay.value:
          return {
            title: "Hotel Reservation",
            quantity: 1,
            amount:
              booking?.booking?.fareTotalPrice || booking?.booking?.grandTotal,
            price: formatMoney(
              booking?.booking?.fareTotalPrice || booking?.booking?.grandTotal
            ),
            total: formatMoney(
              booking?.booking?.fareTotalPrice || booking?.booking?.grandTotal
            ),
            details: [
              booking?.booking?.requestBody?.name,
              `${moment(booking?.booking?.requestBody?.start_date).format(
                "MMM DD"
              )} - ${moment(booking?.booking?.requestBody?.end_date).format(
                "MMM DD"
              )} (${calculateStayNights({
                hotel: booking?.booking?.requestBody,
              })})`,
              accommodationTravellersString({
                rooms: booking?.booking?.requestBody?.rooms,
              }),
            ],
          };
        case configurations.products.tour.value:
          return {
            title: "Tour Reservation",
            quantity: 1,
            amount:
              booking?.booking?.fareTotalPrice || booking?.booking?.grandTotal,
            price: formatMoney(
              booking?.booking?.fareTotalPrice || booking?.booking?.grandTotal
            ),
            total: formatMoney(
              booking?.booking?.fareTotalPrice || booking?.booking?.grandTotal
            ),
            details: [
              booking?.booking?.extraDetails?.productInfo?.title,
              moment(booking?.booking?.travelDate).format("MMMM DD, YYYY"),
            ],
          };
        case configurations.products.flight.value:
          let amount =
            booking?.booking?.flightObj?.grandTotal ||
            booking?.booking?.grandTotal;
          const destinations =
            booking?.booking?.flightObj?.destinations ||
            booking?.booking?.destinations ||
            [];
          const flight = parseFlightRoutesAndTripType({
            destinations,
          });
          const dates = destinations
            ?.map((destination) =>
              moment(destination?.departureDate).format("MMM DD")
            )
            ?.join(" - ");
          return {
            title: "Flight Reservation",
            quantity: 1,
            amount: amount,
            price: formatMoney(amount),
            total: formatMoney(amount),
            details: [flight?.routes, flight?.tripType, dates],
          };
        default:
          return {
            title: "Hotel Reservation",
            quantity: 1,
            amount:
              booking?.booking?.fareTotalPrice || booking?.booking?.grandTotal,
            price: formatMoney(
              booking?.booking?.fareTotalPrice || booking?.booking?.grandTotal
            ),
            total: formatMoney(
              booking?.booking?.fareTotalPrice || booking?.booking?.grandTotal
            ),
            details: [booking?.booking?.requestBody?.name],
          };
      }
    });
  }

  let serviceTotal = services?.reduce((acc, current) => {
    return acc + current?.amount;
  }, 0);

  if (invoice?.tax?.value && invoice?.tax?.taxMethod) {
    let taxAmount = 0;
    const { value, taxMethod } = invoice.tax;

    if (taxMethod === "Percentage") {
      taxAmount = (serviceTotal * value) / 100;
    } else if (taxMethod === "Fixed") {
      taxAmount = value;
    }
    services = [
      ...services,
      {
        title: "Tax",
        quantity: "",
        amount: taxAmount,
        price: "",
        total: formatMoney(taxAmount),
        details: [],
      },
    ];
  }
  if (invoice?.serviceFee?.value && invoice?.serviceFee?.feeMethod) {
    let serviceFeeAmount = 0;
    const { value, feeMethod } = invoice.serviceFee;

    if (feeMethod === "Percentage") {
      serviceFeeAmount = (serviceTotal * value) / 100;
    } else if (feeMethod === "Fixed") {
      serviceFeeAmount = value;
    }
    services = [
      ...services,
      {
        title: "Service fee",
        quantity: "",
        amount: serviceFeeAmount,
        price: "",
        total: formatMoney(serviceFeeAmount),
        details: [],
      },
    ];
  }

  let total = services?.reduce((acc, current) => {
    const raw = current?.total || "";
    const numericTotal = Number(raw.replace(/[^0-9.,]/g, "").replace(/,/g, ""));
    return acc + numericTotal;
  }, 0);

  total = formatMoney(
    total,
    services?.at(0)?.currency === "USD" ? getCurrencySymbol("USD") : undefined
  );

  let pdfData = {
    companyName: user?.detail?.agencyName,
    companyLogo: user?.detail?.agencyLogo,
    invoiceNo: invoice?.invoiceNo,
    customerName: nameArray?.join(" "),
    customerAddress: invoice?.customer?.address,
    companyAddress: user?.detail?.address?.businessLocation,
    notes: invoice?.notes?.join(", "),
    email: invoice?.customer?.email,
    paidOn: "December 7, 2022.",
    paymentDue: moment(invoice?.paymentDue)?.format("MMMM DD, YYYY"),
    issuedOn: moment(invoice?.createdAt)?.format("MMMM DD, YYYY"),
    services: services,
    total: total,
    paymentLink: invoice?.paymentLink,
  };
  return pdfData;
};
